import { render, staticRenderFns } from "./HeartsAnimation.vue?vue&type=template&id=ec4b3824&scoped=true"
import script from "./HeartsAnimation.vue?vue&type=script&lang=js"
export * from "./HeartsAnimation.vue?vue&type=script&lang=js"
import style0 from "./HeartsAnimation.vue?vue&type=style&index=0&id=ec4b3824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4b3824",
  null
  
)

export default component.exports